import React, { Component } from 'react';
import { NavLink, Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import Select, { components } from 'react-select';
import ErrorText from '@tine/lib-frontend-components/components/errors/error-text';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import MapIcon from '@mui/icons-material/Map';

import LoaderPage from 'components/LoaderPage';
import navToggle from 'actions/NavToggle';
import { farmListSuccess, clearMessages } from 'actions/Farms';
import { doLogOut } from 'actions/Login';
import { ENTER_TASKS, ENTER_FIELD, ENTER_STATS, ENTER_FP_PAGE, VIEW_360, KART_CLICKED_MAP, CLICK_STD_SETTINGS } from 'constants/MixPanel';
import { EANA_360 } from 'constants/OauthProperties';
import mixpanel from 'mixpanel-browser';
import { createSvgIcon } from '@mui/material/utils';
import LogoutIcon from '@mui/icons-material/Logout';
import * as appLayoutStyle from 'mui-mobile-components/layouts/AppLayoutStyle';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  Collapse,
  Typography,
  Backdrop
} from '@mui/material';
import {
  ArrowDropDown,
  ArrowRight
} from '@mui/icons-material';

const Icon1 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M4 21V9L12 3L20 9V21H14V14H10V21H4Z" fill="none" stroke="#3F4949" stroke-width="2"/>
  </svg>,
  'icon1'
);

const Icon1Filled = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M4 21V9L12 3L20 9V21H14V14H10V21H4Z" fill="#041F21"/>
  </svg>,
  'icon1filled'
);

const Icon2 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11 21V13.025C9.93333 13.025 8.90833 12.8208 7.925 12.4125C6.94167 12.0042 6.075 11.425 5.325 10.675C4.575 9.925 4 9.05833 3.6 8.075C3.2 7.09167 3 6.06667 3 5V3H5C6.05 3 7.06667 3.20417 8.05 3.6125C9.03333 4.02083 9.9 4.6 10.65 5.35C11.1667 5.86667 11.5958 6.43333 11.9375 7.05C12.2792 7.66667 12.5417 8.325 12.725 9.025C12.8083 8.90833 12.9 8.79583 13 8.6875C13.1 8.57917 13.2083 8.46667 13.325 8.35C14.075 7.6 14.9417 7.02083 15.925 6.6125C16.9083 6.20417 17.9333 6 19 6H21V8C21 9.06667 20.7958 10.0917 20.3875 11.075C19.9792 12.0583 19.4 12.925 18.65 13.675C17.9 14.425 17.0375 15 16.0625 15.4C15.0875 15.8 14.0667 16 13 16V21H11ZM11 11C11 10.2 10.8458 9.4375 10.5375 8.7125C10.2292 7.9875 9.79167 7.34167 9.225 6.775C8.65833 6.20833 8.0125 5.77083 7.2875 5.4625C6.5625 5.15417 5.8 5 5 5C5 5.8 5.15 6.56667 5.45 7.3C5.75 8.03333 6.18333 8.68333 6.75 9.25C7.31667 9.81667 7.96667 10.25 8.7 10.55C9.43333 10.85 10.2 11 11 11ZM13 14C13.8 14 14.5625 13.85 15.2875 13.55C16.0125 13.25 16.6583 12.8167 17.225 12.25C17.7917 11.6833 18.2292 11.0333 18.5375 10.3C18.8458 9.56667 19 8.8 19 8C18.2 8 17.4333 8.15417 16.7 8.4625C15.9667 8.77083 15.3167 9.20833 14.75 9.775C14.1833 10.3417 13.75 10.9875 13.45 11.7125C13.15 12.4375 13 13.2 13 14Z" fill="#3F4949"/>
  </svg>,
  'icon2'
);

const Icon2Filled = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 21V13.025C9.93333 13.025 8.90833 12.8208 7.925 12.4125C6.94167 12.0042 6.075 11.425 5.325 10.675C4.575 9.925 4 9.05833 3.6 8.075C3.2 7.09167 3 6.06667 3 5V3H5C6.05 3 7.06667 3.20417 8.05 3.6125C9.03333 4.02083 9.9 4.6 10.65 5.35C11.1667 5.86667 11.5958 6.43333 11.9375 7.05C12.2792 7.66667 12.5417 8.325 12.725 9.025C12.8083 8.90833 12.9 8.79583 13 8.6875C13.1 8.57917 13.2083 8.46667 13.325 8.35C14.075 7.6 14.9417 7.02083 15.925 6.6125C16.9083 6.20417 17.9333 6 19 6H21V8C21 9.06667 20.7958 10.0917 20.3875 11.075C19.9792 12.0583 19.4 12.925 18.65 13.675C17.9 14.425 17.0375 15 16.0625 15.4C15.0875 15.8 14.0667 16 13 16V21H11Z" fill="#041F21"/>
</svg>,
  'icon2filled'
);

const Icon3 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#3F4949"/>
  </svg>,
  'icon3'
);

const Icon3Filled = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="#041F21"/>
  </svg>,
  'icon3filled'
);

const Icon4 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M4 19H6V11H18V19H20V8.35L12 5.15L4 8.35V19ZM2 21V7L12 3L22 7V21H16V13H8V21H2ZM9 21V19H11V21H9ZM11 18V16H13V18H11ZM13 21V19H15V21H13Z" fill="#3F4949"/>
  </svg>,
  'icon4'
);

const Icon4Filled = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 21V7L12 3L22 7V21H16V13H8V21H2ZM9 21V19H11V21H9ZM11 18V16H13V18H11ZM13 21V19H15V21H13Z" fill="#041F21"/>
  </svg>,
  'icon4filled'
);

const Icon5 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 21C2.45 21 1.97917 20.8042 1.5875 20.4125C1.19583 20.0208 1 19.55 1 19V14C1 13.45 1.19583 12.9792 1.5875 12.5875C1.97917 12.1958 2.45 12 3 12V7.725C2.7 7.54167 2.45833 7.30417 2.275 7.0125C2.09167 6.72083 2 6.38333 2 6V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H9C9.55 3 10.0208 3.19583 10.4125 3.5875C10.8042 3.97917 11 4.45 11 5V6C11 6.38333 10.9083 6.72083 10.725 7.0125C10.5417 7.30417 10.3 7.54167 10 7.725V12H14V7.725C13.7 7.54167 13.4583 7.30417 13.275 7.0125C13.0917 6.72083 13 6.38333 13 6V5C13 4.45 13.1958 3.97917 13.5875 3.5875C13.9792 3.19583 14.45 3 15 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V6C22 6.38333 21.9083 6.72083 21.725 7.0125C21.5417 7.30417 21.3 7.54167 21 7.725V12C21.55 12 22.0208 12.1958 22.4125 12.5875C22.8042 12.9792 23 13.45 23 14V19C23 19.55 22.8042 20.0208 22.4125 20.4125C22.0208 20.8042 21.55 21 21 21H3ZM15 6H20V5H15V6ZM4 6H9V5H4V6ZM16 12H19V8H16V12ZM5 12H8V8H5V12ZM3 19H21V14H3V19Z" fill="#3F4949"/>
  </svg>,
  'icon5'
);

const Icon5Filled = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 21C2.45 21 1.97917 20.8042 1.5875 20.4125C1.19583 20.0208 1 19.55 1 19V14C1 13.45 1.19583 12.9792 1.5875 12.5875C1.97917 12.1958 2.45 12 3 12V7.725C2.7 7.54167 2.45833 7.30417 2.275 7.0125C2.09167 6.72083 2 6.38333 2 6V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H9C9.55 3 10.0208 3.19583 10.4125 3.5875C10.8042 3.97917 11 4.45 11 5V6C11 6.38333 10.9083 6.72083 10.725 7.0125C10.5417 7.30417 10.3 7.54167 10 7.725V12H14V7.725C13.7 7.54167 13.4583 7.30417 13.275 7.0125C13.0917 6.72083 13 6.38333 13 6V5C13 4.45 13.1958 3.97917 13.5875 3.5875C13.9792 3.19583 14.45 3 15 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V6C22 6.38333 21.9083 6.72083 21.725 7.0125C21.5417 7.30417 21.3 7.54167 21 7.725V12C21.55 12 22.0208 12.1958 22.4125 12.5875C22.8042 12.9792 23 13.45 23 14V19C23 19.55 22.8042 20.0208 22.4125 20.4125C22.0208 20.8042 21.55 21 21 21H3ZM16 12H19V8H16V12ZM5 12H8V8H5V12Z" fill="#041F21"/>
  </svg>,
  'icon5filled'
);

const Icon6 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3102 21.0298C15.2102 21.7098 14.5902 22.2498 13.8502 22.2498H10.1502C9.41023 22.2498 8.79023 21.7098 8.70023 20.9798L8.43023 19.0898C8.16023 18.9498 7.90023 18.7998 7.64023 18.6298L5.84023 19.3498C5.14023 19.6098 4.37023 19.3198 4.03023 18.6998L2.20023 15.5298C1.85023 14.8698 2.00023 14.0898 2.56023 13.6498L4.09023 12.4598C4.08023 12.3098 4.07023 12.1598 4.07023 11.9998C4.07023 11.8498 4.08023 11.6898 4.09023 11.5398L2.57023 10.3498C1.98023 9.89977 1.83023 9.08977 2.20023 8.46977L4.05023 5.27977C4.39023 4.65977 5.16023 4.37977 5.84023 4.64977L7.65023 5.37977C7.91023 5.20977 8.17023 5.05977 8.43023 4.91977L8.70023 3.00977C8.79023 2.30977 9.41023 1.75977 10.1402 1.75977H13.8402C14.5802 1.75977 15.2002 2.29977 15.2902 3.02977L15.5602 4.91977C15.8302 5.05977 16.0902 5.20977 16.3502 5.37977L18.1502 4.65977C18.8602 4.39977 19.6302 4.68977 19.9702 5.30977L21.8102 8.48977C22.1702 9.14977 22.0102 9.92977 21.4502 10.3698L19.9302 11.5598C19.9402 11.7098 19.9502 11.8598 19.9502 12.0198C19.9502 12.1798 19.9402 12.3298 19.9302 12.4798L21.4502 13.6698C22.0102 14.1198 22.1702 14.8998 21.8202 15.5298L19.9602 18.7498C19.6202 19.3698 18.8502 19.6498 18.1602 19.3798L16.3602 18.6598C16.1002 18.8298 15.8402 18.9798 15.5802 19.1198L15.3102 21.0298ZM10.6202 20.2498H13.3802L13.7502 17.6998L14.2802 17.4798C14.7202 17.2998 15.1602 17.0398 15.6202 16.6998L16.0702 16.3598L18.4502 17.3198L19.8302 14.9198L17.8002 13.3398L17.8702 12.7798L17.8733 12.7528C17.9023 12.5025 17.9302 12.2604 17.9302 11.9998C17.9302 11.7298 17.9002 11.4698 17.8702 11.2198L17.8002 10.6598L19.8302 9.07977L18.4402 6.67977L16.0502 7.63977L15.6002 7.28977C15.1802 6.96977 14.7302 6.70977 14.2702 6.51977L13.7502 6.29977L13.3802 3.74977H10.6202L10.2502 6.29977L9.72023 6.50977C9.28023 6.69977 8.84023 6.94977 8.38023 7.29977L7.93023 7.62977L5.55023 6.67977L4.16023 9.06977L6.19023 10.6498L6.12023 11.2098C6.09023 11.4698 6.06023 11.7398 6.06023 11.9998C6.06023 12.2598 6.08023 12.5298 6.12023 12.7798L6.19023 13.3398L4.16023 14.9198L5.54023 17.3198L7.93023 16.3598L8.38023 16.7098C8.81023 17.0398 9.24023 17.2898 9.71023 17.4798L10.2402 17.6998L10.6202 20.2498ZM15.5002 11.9998C15.5002 13.9328 13.9332 15.4998 12.0002 15.4998C10.0672 15.4998 8.50023 13.9328 8.50023 11.9998C8.50023 10.0668 10.0672 8.49977 12.0002 8.49977C13.9332 8.49977 15.5002 10.0668 15.5002 11.9998Z" fill="#3F4949"/>
  </svg>,
  'icon6'
);

const Icon6Filled = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.4298 12.98C19.4698 12.66 19.4998 12.34 19.4998 12C19.4998 11.66 19.4698 11.34 19.4298 11.02L21.5398 9.37C21.7298 9.22 21.7798 8.95 21.6598 8.73L19.6598 5.27C19.5398 5.05 19.2698 4.97 19.0498 5.05L16.5598 6.05C16.0398 5.65 15.4798 5.32 14.8698 5.07L14.4898 2.42C14.4598 2.18 14.2498 2 13.9998 2H9.99984C9.74984 2 9.53984 2.18 9.50984 2.42L9.12984 5.07C8.51984 5.32 7.95984 5.66 7.43984 6.05L4.94984 5.05C4.71984 4.96 4.45984 5.05 4.33984 5.27L2.33984 8.73C2.20984 8.95 2.26984 9.22 2.45984 9.37L4.56984 11.02C4.52984 11.34 4.49984 11.67 4.49984 12C4.49984 12.33 4.52984 12.66 4.56984 12.98L2.45984 14.63C2.26984 14.78 2.21984 15.05 2.33984 15.27L4.33984 18.73C4.45984 18.95 4.72984 19.03 4.94984 18.95L7.43984 17.95C7.95984 18.35 8.51984 18.68 9.12984 18.93L9.50984 21.58C9.53984 21.82 9.74984 22 9.99984 22H13.9998C14.2498 22 14.4598 21.82 14.4898 21.58L14.8698 18.93C15.4798 18.68 16.0398 18.34 16.5598 17.95L19.0498 18.95C19.2798 19.04 19.5398 18.95 19.6598 18.73L21.6598 15.27C21.7798 15.05 21.7298 14.78 21.5398 14.63L19.4298 12.98ZM11.9998 15.5C10.0698 15.5 8.49984 13.93 8.49984 12C8.49984 10.07 10.0698 8.5 11.9998 8.5C13.9298 8.5 15.4998 10.07 15.4998 12C15.4998 13.93 13.9298 15.5 11.9998 15.5Z" fill="#041F21"/>
  </svg>,
  'icon6filled'
);

const Icon7 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H12V5H5V19H19V12H21V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM9.7 15.7L8.3 14.3L17.6 5H14V3H21V10H19V6.4L9.7 15.7Z" fill="#3F4949"/>
  </svg>,
  'icon7'
);

class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      storageMenu: false,
      isButtonClicked: false
    };
    this.navBarRef = React.createRef();
  }

  componentDidMount() {
    // Add event listener for clicks outside the menu bar
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    // Clean up event listener
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    // If the button was clicked, don't close the menu
    if (this.state.isButtonClicked) {
      this.setState({ isButtonClicked: false }); // Reset the flag
      return;
    }

    // If the clicked target is outside the nav bar, close the menu
    if (this.navBarRef.current && !this.navBarRef.current.contains(event.target)) {
      this.handleMenuToggleClose();
    }
  };

  handleToggle = menu => {
    let { menu1, menu2, menu3, menu4, menu5 } = this.state;
    if(menu === 'menu1') {
      this.setState({
        menu1: !menu1
      });
    } else if(menu === 'menu2') {
      this.setState({
        menu2: !menu2
      });
    } else if(menu === 'menu3') {
      this.setState({
        menu3: !menu3
      });
    } else if(menu === 'menu4') {
      this.setState({
        menu4: !menu4
      });
    } else {
      this.setState({
        menu5: !menu5
      });
    }
  };

  // handle farm select
  farmChange = item => {
    const { farmList, updateActiveFarm, clearFarmMessages } = this.props;
    const selecteItem = _.filter(farmList.data, ['farm.id', item.value]);
    localStorage.setItem( 'selectedFarmId', selecteItem[0].farm.id );
    localStorage.setItem( 'selectedFarmName', selecteItem[0].farm.name );
    updateActiveFarm(farmList.data, selecteItem[0]);
    clearFarmMessages();
  };

  filterOption = (option, inputValue) =>
    (option.label ? option.label.toString().toLowerCase().match(inputValue.toLowerCase()) || [] : []).length > 0;

  // get farm option
  farmListOption = () => {
    const { farmList, hasSupportAdminRole } = this.props;
    const options = farmList.data && farmList.data.map(data => ({ value: data.farm.id, label: hasSupportAdminRole.data ? data.farm.nameAndOrgNum : data.farm.name }));
    if (farmList.data && farmList.data.length > 1) {
      const defaultOption = {
        value: farmList.activeFarm.farm.id,
        label: hasSupportAdminRole.data ? farmList.activeFarm.farm.nameAndOrgNum : farmList.activeFarm.farm.name
      };
      
      const DropdownIndicator = props => (
        // Have to pass all props to the react select
        // eslint-disable-next-line react/jsx-props-no-spreading
        <components.DropdownIndicator {...props}>
          <span className={props.selectProps.menuIsOpen ? 'icon-arrow-up' : 'icon-arrow-down'} />
        </components.DropdownIndicator>
      );
      return (
        <Select
          options={options}
          value={defaultOption}
          onChange={v => this.farmChange(v)}
          className="farm-header-select"
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator
          }}
          filterOption={this.filterOption}
          styles={{
            menu: (provided) => ({
              ...provided,
              width: 'auto',
              cursor: 'pointer'
            }),
            option: (provided, state) => ({
              ...provided,
              padding: '10px 10px',
              color: state.isSelected ? 'black' : 'black',
              backgroundColor: state.isFocused ? '#E6E9E8' : 'transparent' && state.isSelected ? '#CCE8E9' : 'transparent',
              cursor: 'pointer'
            }),
          }}
        />
      );
    }
    return (
      <span title={options[0].label} className="farm-header-selected-text">
        {options[0].label}
      </span>
    );
  };

  // Hanlde sign out
  handleSignOut = () => {
    const { userDetails, loggingOut, farmList } = this.props;
    loggingOut(userDetails.data.accessToken, farmList.activeFarm?.farm.id)
  };

  // Toggle menu
  handleMenuToggle = () => {
    const { navigationToggle, navBarToggle } = this.props;
    navigationToggle(!navBarToggle.isOpen);
    this.setState({ isButtonClicked: true });
  };

  // Toggle menu
  handleMenuToggleClose = () => {
    const { navigationToggle } = this.props;
    navigationToggle(false);
  };

  render() {
    const {
      intl,
      navBarToggle,
      farmList,
      history,
      userDetails,
      hasSupportAdminRole,
      location
    } = this.props;
    const { storageMenu } = this.state;
    const classToogle = navBarToggle.isOpen ? 'menu-bar toggle' : 'menu-bar';
    const navMenuClass = navBarToggle.isOpen ? 'btn-nav-menu menu-open' : 'btn-nav-menu';
    const hoverEffect = {
      marginLeft: 'auto',
      position: 'relative', // Ensures positioning doesn't affect child elements
      display: 'flex',
      alignItems: 'center', // Keeps the icon vertically aligned
      justifyContent: 'center', // Centers the icon horizontally
      color: '#000000',
      borderRadius: '23px', // Rounded shape (half of the 46px width)
      width: '40px', // The size of the hover effect
      height: '40px', // Ensures it's a perfect circle
      transition: 'background-color 0.3s, width 0.3s, height 0.3s', // Smooth hover transition
    }
    return (
      <>
      <button type="button" onClick={() => this.handleMenuToggle()} className={navMenuClass}>
        <span />
      </button>
      <div ref={this.navBarRef} className={classToogle}>
        <Box style={appLayoutStyle.navigationBarLayout}>
          <Drawer
            variant="permanent"
            anchor="left"
            sx={{
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                background: 'transparent',
                borderRight: 'none',
                borderTopRightRadius: '16px',
                borderBottomRightRadius: '16px'
              },
              background: 'transparent'
            }}
          >
            <Box style={appLayoutStyle.appLayoutBoxContainer}>
              <Typography>
                <Link style={appLayoutStyle.appLayoutTitle} to="/managefields">{intl.formatMessage({ id: 'APP_NAME' })}</Link>
              </Typography>
              <button type="button" onClick={() => this.handleMenuToggleClose()} className={navMenuClass} style={{position: 'absolute'}}>
                <span />
              </button>
              {userDetails.isLogoutLoading ? <LoaderPage /> : null}
              {farmList.data && farmList.data.length > 0 && history.location.pathname !== '/settings/addfarm' ? this.farmListOption() : null}
              {farmList.hasError ? (<ErrorText size="small">{farmList.hasError}</ErrorText>) : null}
              <List sx={{width: '280px'}}>
                {/* Menu 1 */}
                <NavLink to="/stats" onClick={() => {mixpanel.identify(userDetails.data.id); mixpanel.track(ENTER_STATS); this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                  <ListItem sx={{ padding: '0px' }}>
                    <Box style={(location.pathname).includes('stats') ? appLayoutStyle.menuListItemHighlight : appLayoutStyle.menuListItem} 
                    sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, width: '280px'}}>
                      <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}>{(location.pathname).includes('stats') ? <Icon1Filled/> : <Icon1/>}</ListItemIcon>
                      <Typography style={(location.pathname).includes('stats') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                        {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_1' })}
                      </Typography>
                    </Box>
                  </ListItem>
                </NavLink>

                {/* Kart Menu */}
                <Link to="/kart/fieldmap" onClick={() => {mixpanel.identify(userDetails.data.id); mixpanel.track(KART_CLICKED_MAP); this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                  <ListItem sx={{ padding: '0px' }}>
                    <Box style={(location.pathname).includes('fieldmap') ? appLayoutStyle.menuListItemHighlight : appLayoutStyle.menuListItem} 
                    sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, width: '280px'}}>
                      <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}>
                        {(location.pathname).includes('fieldmap') ? <MapIcon sx={{ color: '#041F21' }} /> : <MapOutlinedIcon sx={{ color: '#3F4949' }} />}
                      </ListItemIcon>
                      <Typography style={(location.pathname).includes('fieldmap') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                        {intl.formatMessage({ id: 'KART_BETA' })}
                      </Typography>
                    </Box>
                  </ListItem>
                </Link>

                {/* Menu 2 */}
                <Link to="/managefields" onClick={() => {mixpanel.identify(userDetails.data.id); mixpanel.track(ENTER_FIELD); this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                  <ListItem sx={{ padding: '0px' }}>
                    <Box style={(location.pathname).includes('managefields') ? appLayoutStyle.menuListItemHighlight : appLayoutStyle.menuListItem} 
                    sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, width: '250px'}}>
                      <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}>
                        {(location.pathname).includes('managefields') || (location.pathname).includes('fertilization') || (location.pathname).includes('soilsamplesimport') ? <Icon2Filled/> : <Icon2/>}
                      </ListItemIcon>
                      <Typography style={(location.pathname).includes('managefields') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                        {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_2' })}
                      </Typography>
                    </Box>
                    <Box
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation(); // Prevent the click event from bubbling up
                        this.handleToggle('menu1');
                      }}
                      style={hoverEffect} sx={{'&:hover': {backgroundColor: '#E6E9E8'}}}
                    >
                      {this.state.menu1 ? (<ArrowDropDown sx={{pointerEvents: 'none'}}/>) : (<ArrowRight sx={{pointerEvents: 'none'}}/>)}
                    </Box>

                  </ListItem>
                </Link>
                <Collapse in={this.state.menu1} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <Link to="/fertilization" onClick={() => {mixpanel.identify(userDetails.data.id); mixpanel.track(ENTER_FP_PAGE); this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={(location.pathname).includes('fertilization') ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={(location.pathname).includes('fertilization') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_3' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                    <Link to="/soilsamplesimport" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={(location.pathname).includes('soilsamplesimport') ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={(location.pathname).includes('soilsamplesimport') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_4' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                  </List>
                </Collapse>

                {/* Menu 3 */}
                <Link to="/tasks" onClick={() => { mixpanel.identify(userDetails.data.id); mixpanel.track(ENTER_TASKS); this.handleMenuToggleClose();}}
                  style={{ textDecoration: 'none' }}
                >
                  <ListItem sx={{ padding: '0px' }}>
                    <Box style={(location.pathname).includes('tasks') ? appLayoutStyle.menuListItemHighlight : appLayoutStyle.menuListItem} 
                    sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, width: '240px'}}>
                      <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}>
                        {(location.pathname).includes('tasks') || (location.pathname).includes('task-batch') ? <Icon3Filled/> : <Icon3/>}
                      </ListItemIcon>
                      <Typography style={(location.pathname).includes('tasks') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                        {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_5' })}
                      </Typography>
                    </Box>
                    <Box
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation(); // Prevent the click event from bubbling up
                        this.handleToggle('menu2');
                      }}
                      style={hoverEffect} sx={{'&:hover': {backgroundColor: '#E6E9E8'}}}
                    >
                      {this.state.menu2 ? (<ArrowDropDown sx={{pointerEvents: 'none'}}/>) : (<ArrowRight sx={{pointerEvents: 'none'}}/>)}
                    </Box>
                  </ListItem>
                </Link>
                <Collapse in={this.state.menu2} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <Link to="/task-batch" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={(location.pathname).includes('task-batch') ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={(location.pathname).includes('task-batch') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_6' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                  </List>
                </Collapse>

                {/* Menu 4 */}
                <Link to="/storages" style={{ textDecoration: 'none' }} onClick={() => {this.setState({ storageMenu: false }); this.handleMenuToggleClose();}}>
                  <ListItem sx={{ padding: '0px' }}>
                    <Box style={(location.pathname).includes('storages') && !storageMenu ? appLayoutStyle.menuListItemHighlight : appLayoutStyle.menuListItem} 
                    sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, width: '240px'}}>
                      <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}>
                        {(location.pathname).includes('storages') || (location.pathname).includes('manure-storage') || (location.pathname).includes('mineral-storage') ? <Icon4Filled/> : <Icon4/>}
                      </ListItemIcon>
                      <Typography style={(location.pathname).includes('storages') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                        {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_7' })}
                      </Typography>
                    </Box>
                    <Box
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation(); // Prevent the click event from bubbling up
                        this.handleToggle('menu3');
                      }}
                      style={hoverEffect} sx={{'&:hover': {backgroundColor: '#E6E9E8'}}}
                    >
                      {this.state.menu3 ? (<ArrowDropDown sx={{pointerEvents: 'none'}}/>) : (<ArrowRight sx={{pointerEvents: 'none'}}/>)}
                    </Box>
                  </ListItem>
                </Link>
                <Collapse in={this.state.menu3} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <Link to="/storages" style={{ textDecoration: 'none' }} onClick={() => {this.setState({ storageMenu: true }); this.handleMenuToggleClose();}}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={(location.pathname).includes('storages') && storageMenu ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={(location.pathname).includes('storages') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_8' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                    <Link to="/storage/manure-storage" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={(location.pathname).includes('manure-storage') ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={(location.pathname).includes('manure-storage') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_9' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                    <Link to="/storage/mineral-storage" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={(location.pathname).includes('mineral-storage') ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={(location.pathname).includes('mineral-storage') ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_10' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                  </List>
                </Collapse>

                {/* Menu 5 */}
                <Link to="/grassanalysis" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                  <ListItem sx={{ padding: '0px' }}>
                    <Box style={location.pathname === '/grassanalysis' ? appLayoutStyle.menuListItemHighlight : appLayoutStyle.menuListItem} 
                    sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, width: '240px'}}>
                      <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}>
                        {location.pathname === '/grassanalysis' || location.pathname === '/grassanalysis/search' ? <Icon5Filled/> : <Icon5/>}
                      </ListItemIcon>
                      <Typography style={location.pathname === '/grassanalysis' ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                        {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_11' })}
                      </Typography>
                    </Box>
                    {hasSupportAdminRole.data && <Box
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation(); // Prevent the click event from bubbling up
                        this.handleToggle('menu4');
                      }}
                      style={hoverEffect} sx={{'&:hover': {backgroundColor: '#E6E9E8'}}}
                    >
                      {this.state.menu4 ? (<ArrowDropDown sx={{pointerEvents: 'none'}}/>) : (<ArrowRight sx={{pointerEvents: 'none'}}/>)}
                    </Box>}
                  </ListItem>
                </Link>
                {hasSupportAdminRole.data && 
                <Collapse in={this.state.menu4} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <Link to="/grassanalysis/search" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={location.pathname === '/grassanalysis/search' ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={location.pathname === '/grassanalysis/search' ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'GRASS_ANALYSIS_SEARCH' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                  </List>
                </Collapse>}

                {/* Menu 6 */}
                <Link to="/settings" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                  <ListItem sx={{ padding: '0px' }}>
                    <Box style={location.pathname === '/settings' ? appLayoutStyle.menuListItemHighlight : appLayoutStyle.menuListItem} 
                    sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, width: '240px'}}>
                      <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}>
                        {location.pathname === '/settings' || location.pathname === '/settings/users' || location.pathname === '/settings/vehicle' || location.pathname === '/settings/equipment' ? <Icon6Filled/> : <Icon6/>}
                      </ListItemIcon>
                      <Typography style={location.pathname === '/settings' ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                        {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_12' })}
                      </Typography>
                    </Box>
                    <Box
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation(); // Prevent the click event from bubbling up
                        this.handleToggle('menu5');
                      }}
                      style={hoverEffect} sx={{'&:hover': {backgroundColor: '#E6E9E8'}}}
                    >
                      {this.state.menu5 ? (<ArrowDropDown sx={{pointerEvents: 'none'}}/>) : (<ArrowRight sx={{pointerEvents: 'none'}}/>)}
                    </Box>
                  </ListItem>
                </Link>
                <Collapse in={this.state.menu5} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <Link to="/settings/users" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={location.pathname === '/settings/users' ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={location.pathname === '/settings/users' ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'USERS' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                    <Link to="/settings/vehicle" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={location.pathname === '/settings/vehicle' ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={location.pathname === '/settings/vehicle' ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'VEHICLE' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                    <Link to="/settings/equipment" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={location.pathname === '/settings/equipment' ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={location.pathname === '/settings/equipment' ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'EQUIPMENT' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                    <Link to="/settings/kart" onClick={() => {mixpanel.identify(userDetails.data.id); mixpanel.track(CLICK_STD_SETTINGS); this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={location.pathname === '/settings/kart' ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={location.pathname === '/settings/kart' ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'TOGGLE_SETTINGS_BETA' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>
                    {hasSupportAdminRole.data && 
                    <Link to="/settings/subscriptions" onClick={() => {this.handleMenuToggleClose();}} style={{ textDecoration: 'none' }}>
                      <ListItem sx={{ padding: '0px', pl: 6 }}>
                        <Box style={location.pathname === '/settings/subscriptions' ? appLayoutStyle.listItemHighlight : null}
                        sx={{ pl: 2, "&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px' }, paddingTop: "10px", paddingBottom: "10px", width: '240px' }}>
                          <Typography style={location.pathname === '/settings/subscriptions' ? appLayoutStyle.menuStyleDark : appLayoutStyle.menuStyle}>
                            {intl.formatMessage({ id: 'SETTINGS_SUBSCRIPTIONS' })}
                          </Typography>
                        </Box>
                      </ListItem>
                    </Link>}
                  </List>
                </Collapse>

                {/* Menu 7 */}
                <a href={EANA_360} onClick={() => {mixpanel.identify(userDetails.data.id); mixpanel.track(VIEW_360);}} style={{ textDecoration: 'none' }}>
                  <ListItem sx={{ padding: '0px' }}>
                    <Box style={appLayoutStyle.menuListItem} sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px', width: '280px' }}}>
                      <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}><Icon7 /></ListItemIcon>
                      <Typography style={appLayoutStyle.menuStyle}>
                        {intl.formatMessage({ id: 'MUI_NAVIGATION_BAR_13' })}
                      </Typography>
                    </Box>
                  </ListItem>
                </a>

                {/* Menu 8 */}
                <ListItem sx={{ padding: '0px' }}>
                  <Box style={appLayoutStyle.menuListItem} sx={{"&:hover": { backgroundColor: "#E6E9E8", borderRadius: '100px', width: '280px', cursor: 'pointer' }}} onClick={() => this.handleSignOut()}>
                    <ListItemIcon sx={{minWidth: '20px !important', marginRight: 2}}><LogoutIcon sx={{ color: '#3F4949' }} /></ListItemIcon>
                    <Typography style={appLayoutStyle.menuStyle}>
                      {intl.formatMessage({ id: 'logOut' })}
                    </Typography>
                  </Box>
                </ListItem>
              </List>
            </Box>
          </Drawer>
          <Backdrop style={{opacity: '0.6', backgroundColor: '#000000'}} open={true} onClick={() => {this.handleMenuToggleClose();}}></Backdrop>
        </Box>
      </div>
      </>
    );
  }
}
const mapStateToProps = state => ({
  navBarToggle: state.NavToggle,
  farmList: state.farmList,
  hasValidationPermision: state.GpsData,
  userDetails: state.userDetails,
  hasSupportAdminRole: state.SupportAdminRole
});

const mapDispatchToProps = dispatch => ({
  navigationToggle: bool => dispatch(navToggle(bool)),
  updateActiveFarm: (data, activeform) => dispatch(farmListSuccess(data, activeform)),
  clearFarmMessages: () => dispatch(clearMessages()),
  loggingOut: (token, activeFarmId) => dispatch(doLogOut(token, activeFarmId))
});

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(NavigationBar)));
